import getActualSortedOrder from './getActualSortedOrder';

export default (payloads, order) => {
  const data = payloads.filter((item) => item.order !== order);

  return getActualSortedOrder(data);
};
